import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams, Redirect } from 'react-router';
import { saveJob } from '../dashboard/service';
import JobDetailCard from '../../components/job-detail-card';
import DetailSidebar from '../../components/detail-sidebar/detail-sidebar';
import Loader from '../../components/loader';
import { fetchJob } from '../../hoc/services/get-job';
import { constructEncodedUrl, deconstructEncodedUrl } from '../../utils/helpers';
import { useAppliedJobs } from '../../hooks/useAppliedJobs';
import { useSavedJobs } from '../../hooks/useSavedJobs';

const AppliedJobDetail = (props) => {
  const { userInfo } = props;

  if (userInfo?.user_type == 'recruiter') {
    return <Redirect to="/candidates" />;
  }
  const history = useHistory();
  const { id } = useParams();
  const decompressed = deconstructEncodedUrl(id);
  const [skip, setSkip] = useState(
    history.location.state?.from || decompressed?.filters?.from || 0
  );
  const [limit] = useState(decompressed.filters.size);
  const [savingJobId, setSavingJobId] = useState(null);
  const [unAvailablePost] = useState(decompressed?.filters?.unavilablePost || false);

  const { appliedJobs, isLoading } = useAppliedJobs();

  const {
    jobs: savedJobs,
    refetch: refetchSavedJobs,
    isFetching: SavedJobsFetching,
  } = useSavedJobs();

  const { mutate } = useMutation(saveJob, {
    onSettled: () => refetchSavedJobs(),
    onMutate: (id) => setSavingJobId(id),
    useErrorBoundary: (error) => {
      return error.response.status === 401;
    },
    retry: (count, error) => {
      if (error.response.status === 401) {
        return false;
      } else if (count <= 3) {
        return true;
      } else {
        false;
      }
    },
  });

  const { data: job, isLoading: jobLoading } = useQuery(
    ['fetch-job', { id: decompressed.id }],
    fetchJob,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      useErrorBoundary: (error) => {
        return error.response.status === 401;
      },
      retry: (count, error) => {
        if (error.response.status === 401) {
          return false;
        } else if (count <= 3) {
          return true;
        } else {
          false;
        }
      },
    }
  );

  const data = {
    jobs: appliedJobs?.slice(skip, skip + limit),
    totalJobs: appliedJobs?.length,
  };

  const onPaginate = (type) => {
    if (type === 'next' && !(data?.jobs?.length < limit)) {
      history.push(history.location.pathname, { from: skip + limit });
    } else if (type === 'prev' && skip) {
      history.push(history.location.pathname, { from: skip - limit });
    } else {
      return;
    }
  };

  const onJobSelected = (jobId, params) => {
    return constructEncodedUrl(
      {
        id: jobId,
        filters: { ...decompressed.filters, from: skip, size: limit, ...params },
        view: decompressed?.view,
      },
      'job/applied'
    );
  };

  useEffect(() => {
    if (!SavedJobsFetching) {
      if (savingJobId !== null) {
        setSavingJobId(null);
      }
    }
  }, [SavedJobsFetching]);

  useEffect(() => {
    if (history.location.state?.from === 0) {
      setSkip(0);
    }
  }, [history.location.state?.from]);

  if (isLoading) {
    return (
      <div className="detail-loader">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {decompressed.filters != undefined && (
        <div className="w-320px">
          <div className="row sticky-header">
            <div className="col-xs-12 col-md-12 mb-2 col-xl-12">
              <div className="sticky-header">
                <DetailSidebar
                  greyOut={true}
                  header="Applied Jobs"
                  bodyKey="description"
                  onPaginate={onPaginate}
                  jobType="applied"
                  data={{ ...data, skip, limit }}
                  selectedItemId={decompressed.id}
                  onSelectItem={onJobSelected}
                  onNavigateBack={() =>
                    history.push('/jobs/applied', {
                      skip: decompressed.filters.from,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className={`w-${
          decompressed.filters != undefined ? '75' : '100'
        } cx-padding`}
      >
        {jobLoading && (
          <div className="d-flex flex-column h-100">
            <Loader className="h-100" />
          </div>
        )}
        {unAvailablePost && !jobLoading && (
          <div className="card w-100 text-left p-4">
            <h4 className="bb">About Job</h4>
            <p className="mb-0 text-grey">This position is no longer available</p>
          </div>
        )}
        {!jobLoading && !unAvailablePost && (
          <JobDetailCard
            applied
            userInfo={userInfo}
            job={job}
            mutate={mutate}
            savedJobs={savedJobs?.map((i) => i.id)}
            appliedJobs={appliedJobs}
            savingJobId={savingJobId}
          />
        )}
      </div>
    </>
  );
};

AppliedJobDetail.propTypes = {
  userInfo: PropTypes.any,
};

AppliedJobDetail.defaultProps = {
  userInfo: null,
};

export default AppliedJobDetail;
